import {API_URL, apiPut} from '../api'

export const updateNews = async (id: string, is_active?: boolean) => {
    return await apiPut(API_URL, `admin/hub/trending/${id}`, {is_active: is_active})
}
